import { AdsPage } from '../../../projects/shared-lib/src/lib/models/ads-page';


const showId1650066437 = {
    imageUrl:
        'https://ticketpro.s3.us-east-1.amazonaws.com/ww1/suggestion/dracula_suggestion_1920x1080_video_en.png',
    title: 'Hotel Dracula: A terrifying immersive experience is waiting for you in Montreal!',
    description:
        "Wearing a VR headset, you'll be immersed in a fascinating world filled with wonder and mystery. Explore a life-sized haunted house and come face-to-face with legendary creatures like Dracula, Frankenstein, zombies, and many more.",
    url: 'https://tproqc.ticketpro.ca/en/pages/HotelDracula?t=cartsuggestion',
    videoUrl: 'https://www.youtube.com/embed/IZl8Nb-zuU0',

    imageUrlFr:
        'https://ticketpro.s3.us-east-1.amazonaws.com/ww1/suggestion/dracula_suggestion_1920x1080_video_fr.png',
    titleFr:
        'Hôtel Dracula : une expérience immersive terrifiante vous attend à Montréal !',
    descriptionFr:
        "Équipé d'un casque VR, vous serez plongé dans un univers fascinant, entre émerveillement et mystère. Vous découvrirez un manoir hanté grandeur nature, rencontrerez des créatures mythiques comme Dracula, Frankenstein, des zombies, et bien d'autres.",
    urlFr: 'https://tproqc.ticketpro.ca/fr/pages/HotelDracula?t=cartsuggestion',
    videoUrlFr: 'https://www.youtube.com/embed/IZl8Nb-zuU0',

    showIds: [1650066437],
};
export const listAdsPages: AdsPage[] = [];
